import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import FaqContent from './FaqContent'
export default class Faq extends Component {

    

    render() {

        let id = this.props.match.params.id;
        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <FaqContent id={id} />
                <Footer />

            </div>


        )
    }
}
